import { EXPORT_STATUS_READY_STRING } from "actions/api/exports/actions";
import { useToastContext } from "hooks/useToastContext";
import { useTranslation } from "react-i18next";
import { useGenerateExport } from "@weezevent/gofast-front";
import { useCallback } from "react";

export const useExport = () => {
	const { t } = useTranslation();

	const { error, success } = useToastContext();

	const generateExport = useGenerateExport({
		onSuccess: () => {
			success(t("access.common.exportBegin"));
		},
		onFailure: () => {
			error(t("access.common.exportError"));
		},
		onValidationSuccess: () => {
			success("The export will be generated in csv");
		},
		onValidationAbort: () => {
			error("The export process is aborted");
		}
	});

	const createExport = useCallback(
		(process, exportData) => {
			generateExport.trigger({
				process,
				status: EXPORT_STATUS_READY_STRING,
				data: exportData
			});
		},
		[generateExport]
	);

	return { createExport };
};
